import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialEchoPage() {
    const navigate = useNavigate();
    const [input, setInput] = useState('');
    const [words, setWords] = useState([]); // { text, x, y, size }

    const addWord = (e) => {
        if (e.key !== 'Enter' || !input.trim()) return;

        // Random position and slightly random size based on repetition logic (simulated here)
        const size = Math.floor(Math.random() * 30) + 20; // 20-50px
        const x = Math.floor(Math.random() * 80) + 10; // 10-90%
        const y = Math.floor(Math.random() * 80) + 10;

        setWords([...words, { text: input, x, y, size, color: getRandomColor() }]);
        setInput('');
    };

    const getRandomColor = () => {
        const colors = ['#3b82f6', '#ef4444', '#22c55e', '#f59e0b', '#8b5cf6', '#ec4899'];
        return colors[Math.floor(Math.random() * colors.length)];
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#000', color: 'white', fontFamily: 'Inter, sans-serif', position: 'relative', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>

            {/* WORD CLOUD AREA */}
            <div style={{ flex: 1, position: 'relative' }}>
                {words.map((w, i) => (
                    <div
                        key={i}
                        className="float-word"
                        style={{
                            position: 'absolute', left: `${w.x}%`, top: `${w.y}%`,
                            fontSize: w.size, color: w.color, fontWeight: 900, opacity: 0.8,
                            transform: 'translate(-50%, -50%)', textShadow: `0 0 20px ${w.color}`
                        }}
                    >
                        {w.text}
                    </div>
                ))}

                {words.length === 0 && (
                    <div style={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center', opacity: 0.3, fontSize: '2rem' }}>
                        Écoutez le client... Tapez les mots clés.
                    </div>
                )}
            </div>

            {/* INPUT BAR */}
            <div style={{ padding: 20, background: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(10px)', display: 'flex', gap: 20 }}>
                <input
                    autoFocus
                    type="text"
                    placeholder="Tapez un mot clé..."
                    value={input}
                    onChange={e => setInput(e.target.value)}
                    onKeyDown={addWord}
                    style={{ flex: 1, padding: '15px 25px', borderRadius: 50, border: 'none', background: 'black', color: 'white', fontSize: '1.2rem', outline: 'none' }}
                />
                <button onClick={() => setWords([])} style={{ padding: '0 30px', borderRadius: 50, border: '1px solid rgba(255,255,255,0.2)', background: 'transparent', color: 'white', cursor: 'pointer' }}>Reset 🗑️</button>
                <button onClick={() => navigate('/commercial/launchpad')} style={{ padding: '0 30px', borderRadius: 50, border: 'none', background: '#333', color: 'white', cursor: 'pointer' }}>Quitter</button>
            </div>

            <style>{`.float-word { animation: float 5s ease-in-out infinite alternate; } @keyframes float { from { transform: translate(-50%, -50%) scale(1); } to { transform: translate(-50%, -50%) scale(1.1); } }`}</style>
        </div>
    );
}
